import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "./App.scss";
import ReactGA from "react-ga4";
import { NavigatingRoutes } from "./routes/Routes";
import useSetPrivilegesFromAuth from "./hooks/useSetPrivilegesFromAuth";
import { useEffect } from "react";
import { deleteAllCookies } from "./utils/Utils";
import { useAppVersionCheck } from "./hooks/useAppVersionCheck";
import { initChatStreamListener } from "./Components/Bank/widget/EWiChatBot/chatStreamHandler";

const App = () => {
  useAppVersionCheck();
  useSetPrivilegesFromAuth();
  useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      ReactGA?.initialize("G-HMK24027ED");

      ReactGA?.send({
        hitType: "pageview",
        page: globalThis.location.pathname,
        title: "App.jsx",
      });
    }
    return deleteAllCookies();
  }, []);

  useEffect(() => {
    initChatStreamListener();
  }, []);

  return <NavigatingRoutes />;
};

export default App;
